import { useEffect, useState } from 'react';

export const useScrollOver = (offset: number): boolean => {
  const [isOver, setIsOver] = useState<boolean>(window.scrollY > offset ? true : false);
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > offset) {
        setIsOver(true);
      } else {
        setIsOver(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [setIsOver]);
  return isOver;
};
